import { SET_TOP_BAR_TITLE } from '../actions/types';

export default (state = { title: 'Chowreach' }, action) => {
  switch (action.type) {
    case SET_TOP_BAR_TITLE:
      return {
        ...state,
        title: action.payload,
      };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/TopBar.reducer.js